var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4996 0.835938C15.985 0.835938 17.9997 2.90564 17.9997 5.45875V11.9307C17.9997 12.3549 17.7186 12.7248 17.318 12.8276L14.3996 13.5771V18.4026C14.3996 18.9133 13.9967 19.3272 13.4996 19.3272C13.0026 19.3272 12.5996 18.9133 12.5996 18.4026V1.7605C12.5996 1.24988 13.0026 0.835938 13.4996 0.835938ZM14.3996 11.6711L16.1997 11.2088V5.45875C16.1997 4.25107 15.4483 3.22366 14.3996 2.84289V11.6711Z",
    fill: "#1EB865"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80003 1.7605C1.80003 1.24988 1.39708 0.835938 0.900017 0.835938C0.402951 0.835938 0 1.24988 0 1.7605V5.45875C0 7.69523 1.54601 9.56077 3.60007 9.98909V18.4026C3.60007 18.9133 4.00302 19.3272 4.50008 19.3272C4.99715 19.3272 5.4001 18.9133 5.4001 18.4026V9.98909C7.45415 9.56077 9.00017 7.69523 9.00017 5.45875V1.7605C9.00017 1.24988 8.59722 0.835938 8.10015 0.835938C7.60309 0.835938 7.20013 1.24988 7.20013 1.7605V5.45875C7.20013 6.66643 6.44879 7.69384 5.4001 8.07461V1.7605C5.4001 1.24988 4.99715 0.835938 4.50008 0.835938C4.00302 0.835938 3.60007 1.24988 3.60007 1.7605V8.07461C2.55137 7.69384 1.80003 6.66643 1.80003 5.45875V1.7605Z",
    fill: "#1EB865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIcon);
export default __webpack_public_path__ + "static/media/total-icon.8a01b621c1426109998fd4ec7ebb728d.svg";
export { ForwardRef as ReactComponent };